<template>
  <Icon :component="DeleteSvg" class="icon" />
</template>

<script lang="ts">
import { defineComponent, markRaw } from 'vue';
import Icon from '@ant-design/icons-vue';
import DeleteSvg from './svg/DeleteSvg.vue';

export default defineComponent({
  name: 'DeleteIcon',
  components: {
    Icon
  },
  props: {},
  data() {
    return {
      DeleteSvg: markRaw(DeleteSvg)
    };
  }
});
</script>

<style lang="scss" scoped>
.icon {
  color: $primary-color;
  &:hover {
    color: $primary-hover-color;
  }
}
</style>
